export default __webpack_public_path__ + "static/media/Sitansu Ranjan Swain.46f155b1.png";